import styles from './HowToBeAdded.module.scss';
export const HowToBeAdded = () => {
  return (
    <div className={styles.container}>
      <h3 className={styles.title}>How to be added to the Money Lists</h3>
      <ul>
        <li>
          You can download Coinbase free cryptocurrency wallet to automatically
          collect your earnings. Click here to download.
        </li>
        <li>
          To purchase Bitcoin cryptocurrency from Coinbase you must first create
          an account with them.
        </li>
        <li>Select one of our six Global Money Lists to enter.</li>
        <li>
          Add up the total amount to be paid to selected members for that Money
          list, then make sure you already have that amount in Bitcoin.
        </li>
        <li>
          You’re now taken to a page where the money list you selected is now
          present.
        </li>
        <li>
          Click on the required number of members randomly rotating through the
          money list starting at #1.
        </li>
        <li>
          You must now click on the copy button to copy the selected member
          Bitcoin address and pay them the required amount using your
          cryptocurrency wallet. You must send Bitcoin to a Bitcoin address or
          you will lose the sent money and you will not be able to get it back!
        </li>
        <li>
          Each of the members who username you’ve clicked on in the money list
          will be paid directly by you from your cryptocurrency wallet into
          their cryptocurrency wallet.
        </li>
        <li>
          Once payment is made to selected member, you must copy and paste the
          correct transaction identification code from payment receipt into the
          designated slot and then click on verify button. You must verify each
          payment made to the selected members to be added to the money list.
          Each payment made will be verified through the blockchain, to assure
          you this system is cheat proof.
        </li>
        <li>
          If you signed up through one of our members affiliate links that
          member will automatically be locked in the #1 position of the money
          list and receive the first payment.
        </li>
      </ul>
    </div>
  );
};
